import {AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {ImportadorCsvService} from "../services/importador-csv.service";
import {FileRestrictions} from "@progress/kendo-angular-upload";

import {
  PainelImportacaoProdutosComponent
} from "../compartilhado/painel-importacao-produtos/painel-importacao-produtos.component";
import {ModalKendo} from "../lib/ModalKendo";

@Component({
  selector: 'app-importador-csv',
  templateUrl: './importador-csv.component.html',
  styleUrls: ['./importador-csv.component.scss']
})
export class ImportadorCsvComponent extends ModalKendo implements OnInit, AfterViewInit {
  @ViewChild('frm', {static: true}) frm: NgForm;
  @ViewChild('painelImportacao', {static: false}) painelImportacao: PainelImportacaoProdutosComponent;
  @Input()   empresa: any = {};
  @Input()   catalogo: any = {};
  importando: boolean;
  carregando: boolean;
  mensagemSucesso: string;
  mensagemErro: string;
  importou: boolean;
  files: any = {};
  opcoes: any = {}
  tipoImportar = {
    tipo: 'Produto',
    colunas: [
      {descricao: "ID"}, {descricao: 'TipoLinha'}, {descricao: 'Referencia'}, {descricao: 'ReferenciaPai'},
      {descricao: 'Nome'}, {descricao:  'Preço'}, {descricao: 'Imagem (URL)', codigo: 'LinkImagem'},
      {descricao : 'Categoria'} , {descricao: 'Descricao'}, {descricao: 'CodigoPDV'},
      {descricao: 'TipoSelecao'}, {descricao: 'Minimo'},
      {descricao: 'Maximo'}, {descricao: 'PermiteRepetir'}, {descricao: 'TipoCobranca'},
      {descricao: 'MultiplicaQuantidadeProduto'}, {descricao: 'Disponivel'}, {descricao: 'Delivery'},
      {descricao: 'Mesa'}, {descricao: 'Ordem'}, {descricao: 'MaximoPorOpcao'},
      {descricao: 'NomeAdicional'}, {descricao: 'OpcaoAdicional'}]
  }
  colunaIgnorar = {descricao: 'Não importar', ignorar: true}
  opcoesColuna: any = []
  restricoes: FileRestrictions = {
    allowedExtensions: ['.csv'],
    maxFileSize: 10 * 1024 * 1024
  };
  arquivo: File;
  conteudoArquivo: Array<any>;
  colunasImportar: any = [];
  somentePrecos: boolean;
  separadorDecimal: any;
  separadorColunas: string;
  separadorDecimalDetectado = false;
  valorExemploPreco: number;
  larguraDaJanela: string = null;
  buscarProdutos = true;
  tudoSincronizado = false;
  opcoesSeparadorDecimal: any = [
    {codigo: ',', descricao: "Separado por vírgula (,)"},
    {codigo: '.', descricao: "Separado por ponto (.)"}
  ]
  constructor( private importador: ImportadorCsvService,
               private elementoHost: ElementRef) {
    super()
  }
  ngOnInit(): void {
    this.separadorDecimal = this.opcoesSeparadorDecimal[0]

    if(this.somentePrecos){
      this. tipoImportar.colunas  = [
        {descricao: "ID"},  {descricao: 'CodigoPDV'}, {descricao:  'Preço'}
      ]
    }

    this.opcoesColuna = [this.colunaIgnorar, ...this.tipoImportar.colunas]
  }

  /** Coluna sem destino: fica visível, apagada e fora da importação. */
  colunaIgnorada(item: any) {
    return !item?.coluna || !!item.coluna.ignorar
  }

  ngAfterViewInit(): void {
    this.ajusteTamanhoDaJanela()
  }

  get titulo() {
    return this.somentePrecos ? 'Atualizar preços por CSV' : 'Importar produtos por CSV'
  }

  get nomeCatalogo() {
    return this.catalogo?.nome || this.empresa?.catalogo?.nome || 'Catálogo atual'
  }

  get escolheuArquivo() {
    return !!this.conteudoArquivo?.length
  }

  /** A janela só fica larga quando existe tabela para conferir. */
  get modoCompacto() {
    return this.buscarProdutos && (!this.escolheuArquivo || this.importando || this.importou)
  }

  get colunasAceitas() {
    return this.tipoImportar.colunas.map((item: any) => item.descricao)
  }

  get quantidadeLinhasArquivo() {
    return Math.max((this.conteudoArquivo?.length || 0) - 1, 0)
  }

  get quantidadeColunasMapeadas() {
    return this.colunasImportar.filter((item: any) => !this.colunaIgnorada(item)).length
  }

  get camposObrigatoriosPendentes() {
    const camposMapeados = this.colunasImportar
      .filter((item: any) => !this.colunaIgnorada(item))
      .map((item: any) => this.obtenhaCodigoColuna(item.coluna))

    const obrigatorios = this.somentePrecos ? ['CodigoPDV', 'Preço'] : ['Nome', 'Preço']

    return obrigatorios.filter((campo: string) => !camposMapeados.includes(campo))
  }

  get podeImportar() {
    if(!this.arquivo || !this.separadorDecimal || !this.conteudoArquivo?.length)
      return false

    const camposMapeados = this.colunasImportar
      .filter((item: any) => !this.colunaIgnorada(item))
      .map((item: any) => this.obtenhaCodigoColuna(item.coluna))

    if(this.somentePrecos)
      return camposMapeados.includes('Preço') && camposMapeados.includes('CodigoPDV')

    return camposMapeados.includes('Preço') && camposMapeados.includes('Nome')
  }

  feche() {
    this.fecheModal(this.importou)
  }

  onSubmit() {
    this.fecheMensagemErro();
    if(!this.arquivo) {
      this.mensagemErro = 'É necessário escolher um arquivo antes de iniciar a importação.'
      return;
    }

    if(!this.separadorDecimal) {
      this.mensagemErro = 'É necessário escolher o separador decimal do campo preço antes de iniciar a importação'
      return;
    }

    let opcoes: any = {}
    opcoes.colunas = {}

    opcoes.separadorDecimal = this.separadorDecimal
    opcoes.separadorColunas = this.separadorColunas
    let i = 0;

    let selecionouPreco = false, selecionouNome = false, selecionouCodigoPdv = false;

    for(let coluna of this.colunasImportar) {
      if(!this.colunaIgnorada(coluna)) {
        const codigoColuna = this.obtenhaCodigoColuna(coluna.coluna)
        opcoes.colunas[i] = codigoColuna

        if(codigoColuna === 'Preço')
          selecionouPreco = true;

        if(codigoColuna === 'Nome')
          selecionouNome = true;

        if(codigoColuna === 'CodigoPDV')
          selecionouCodigoPdv = true;

      }
      i++
    }

    if(!this.somentePrecos){
      if(!selecionouPreco || !selecionouNome) {
        this.mensagemErro = 'É necessário selecionar ao menos uma coluna para Nome e outra coluna para Preço do produto antes de importar'
        return;
      }

      this.importando = true;
      this.ajusteTamanhoDaJanela();
      this.importador.importe(this.empresa.id, this.arquivo, opcoes).then((resposta: any) => {
        console.log(resposta)
        this.mensagemSucesso = "Foram importadas " + resposta.categoriasInseridas + " categorias e " + resposta.produtosInseridos + " produtos."
        this.importando = false;
        this.importou = true;
        this.ajusteTamanhoDaJanela();

      }).catch((erro: any) => {
        console.log(erro);
        this.mensagemErro = erro;
        this.importando = false;
        this.ajusteTamanhoDaJanela();
      })
    } else {
      if(!selecionouPreco || !selecionouCodigoPdv) {
        this.mensagemErro = 'É necessário selecionar ao menos uma coluna para Codigo Pdv e outra coluna para Preço do produto antes de atualizar'
        return;
      }
      this.carregando = true;
      this.importador.obtenhaPrecosCsv(this.catalogo.id, this.arquivo, opcoes).then((resposta: any) => {
        this.carregando = false;
        this.buscarProdutos = false;
        this.ajusteTamanhoDaJanela();
        this.tudoSincronizado = !  resposta.categorias.length;

        if(!this.empresa || !this.empresa.id) this.painelImportacao.setModoRede(this.catalogo);
        this.painelImportacao.setProdutosSincronizar([], resposta.produtosAtualizar, [],
          resposta.categorias)

      }).catch((erro: any) => {
        console.log(erro);
        this.mensagemErro = erro;
        this.carregando = false;
      })
    }

  }

  fecheMensagemErro() {
    delete this.mensagemErro;
  }
  volteTela(){
    this.painelImportacao.setProdutosSincronizar([],  [], [], []);
    this.buscarProdutos = true;
    this.ajusteTamanhoDaJanela();
  }

  /** Volta para a escolha do arquivo, descartando o que já foi lido. */
  limpeArquivo() {
    this.arquivo = null
    this.files = {}
    this.conteudoArquivo = []
    this.colunasImportar = []
    this.separadorColunas = null
    this.separadorDecimalDetectado = false
    this.valorExemploPreco = null
    this.fecheMensagemErro()
    this.ajusteTamanhoDaJanela()
  }

  /** A roda do mouse anda para os lados na grid; nas pontas volta a rolar a tela. */
  rodouMouseNaTabela(evento: WheelEvent) {
    const area = evento.currentTarget as HTMLElement

    if(!area || area.scrollWidth <= area.clientWidth)
      return

    const fator = evento.deltaMode === 1 ? 16 : 1
    const deslocamento = (Math.abs(evento.deltaX) > Math.abs(evento.deltaY) ? evento.deltaX : evento.deltaY) * fator

    if(!deslocamento)
      return

    const anterior = area.scrollLeft
    area.scrollLeft += deslocamento

    if(area.scrollLeft !== anterior)
      evento.preventDefault()
  }

  escolhaSeparadorDecimal(opcao: any) {
    this.separadorDecimal = opcao
    this.separadorDecimalDetectado = false
    this.fecheMensagemErro()
  }

  /** Mostra o mesmo preço do arquivo nos dois formatos, para a escolha ser visual. */
  exemploPreco(opcao: any) {
    const valor = this.valorExemploPreco > 0 ? this.valorExemploPreco : 29.9
    const texto = valor.toFixed(2)

    return opcao.codigo === ',' ? texto.replace('.', ',') : texto
  }

  /**
   * A janela encolhe na escolha do arquivo, cresce na conferência das colunas
   * e fica acima da barra fixa do painel.
   */
  private ajusteTamanhoDaJanela() {
    setTimeout(() => {
      const host: HTMLElement = this.elementoHost?.nativeElement
      const janela: HTMLElement = host?.closest('.k-dialog')

      if(!janela) return

      const moldura: HTMLElement = host?.closest('.k-dialog-wrapper')

      if(this.larguraDaJanela === null)
        this.larguraDaJanela = janela.style.width

      janela.style.height = 'auto'
      janela.style.transition = 'width 260ms cubic-bezier(0.4, 0, 0.2, 1)'
      janela.style.width = this.modoCompacto ? 'min(660px, calc(100vw - 32px))' : this.larguraDaJanela

      // A navbar do painel é fixa com z-index 100000: o modal precisa cobri-la.
      // O fundo escuro fica dentro desta moldura, então sobe junto.
      if(moldura) {
        moldura.style.zIndex = '100001'
        moldura.style.marginTop = '0'
      }
    })
  }

  parseCSV(text: string) {
    const linhas = text
      .split(/\r?\n/)       // divide em linhas
      .filter(l => l.trim()) // remove linhas vazias
    const separador = this.obtenhaSeparadorColunas(linhas[0] || '')

    return linhas
      .map(l => this.CSVtoArray(l, separador))
      .filter(linha => !!linha);
  }

  obtenhaSeparadorColunas(text: string) {
    let virgulas = 0
    let pontosEVirgulas = 0
    let dentroDeAspas = false

    for(let i = 0; i < text.length; i++) {
      if(text[i] === '"') {
        if(dentroDeAspas && text[i + 1] === '"')
          i++
        else
          dentroDeAspas = !dentroDeAspas
      } else if(!dentroDeAspas && text[i] === ',')
        virgulas++
      else if(!dentroDeAspas && text[i] === ';')
        pontosEVirgulas++
    }

    return pontosEVirgulas > virgulas ? ';' : ','
  }

  CSVtoArray(text: string, separador?: string) {
    const delimitador = separador || this.obtenhaSeparadorColunas(text)
    const colunas: string[] = []
    let valor = ''
    let dentroDeAspas = false

    for(let i = 0; i < text.length; i++) {
      const caractere = text[i]

      if(caractere === '"') {
        if(dentroDeAspas && text[i + 1] === '"') {
          valor += '"'
          i++
        } else
          dentroDeAspas = !dentroDeAspas
      } else if(caractere === delimitador && !dentroDeAspas) {
        colunas.push(valor.trim())
        valor = ''
      } else
        valor += caractere
    }

    if(dentroDeAspas)
      return null

    colunas.push(valor.trim())
    return colunas;
  };

  obtenhaCodigoColuna(coluna: any) {
    return coluna.codigo || coluna.descricao
  }

  obtenhaColuna(nome: string){
    return this.tipoImportar.colunas.find((item: any) => this.obtenhaCodigoColuna(item) === nome)
  }

  obtenhaNomeColunaPorCabecalho(cabecalho: string) {
    const normalizado = String(cabecalho || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-zA-Z0-9]/g, '')
      .toUpperCase();
    const aliases: any = {
      ID: 'ID',
      TIPOLINHA: 'TipoLinha',
      REFERENCIA: 'Referencia',
      REFERENCIAPAI: 'ReferenciaPai',
      PRODUTO: 'Nome',
      NOME: 'Nome',
      PRECO: 'Preço',
      CATEGORIA: 'Categoria',
      DESCRICAO: 'Descricao',
      CODPDV: 'CodigoPDV',
      CODIGOPDV: 'CodigoPDV',
      IMAGEM: 'LinkImagem',
      IMAGEM1: 'LinkImagem',
      IMAGEMURL: 'LinkImagem',
      LINKIMAGEM: 'LinkImagem',
      LINKDAIMAGEM: 'LinkImagem',
      URLIMAGEM: 'LinkImagem',
      URLIMAGEM1: 'LinkImagem',
      URLDAIMAGEM: 'LinkImagem',
      TIPOSELECAO: 'TipoSelecao',
      MINIMO: 'Minimo',
      MAXIMO: 'Maximo',
      PERMITEREPETIR: 'PermiteRepetir',
      TIPOCOBRANCA: 'TipoCobranca',
      MULTIPLICAQUANTIDADEPRODUTO: 'MultiplicaQuantidadeProduto',
      DISPONIVEL: 'Disponivel',
      DELIVERY: 'Delivery',
      MESA: 'Mesa',
      ORDEM: 'Ordem',
      MAXIMOPOROPCAO: 'MaximoPorOpcao',
      NOMEADICIONAL: 'NomeAdicional',
      OPCAOADICIONAL: 'OpcaoAdicional'
    };

    return aliases[normalizado];
  }

  /**
   * Descobre o separador decimal olhando os valores de preço do arquivo.
   * Retorna ',' , '.' ou null quando o arquivo não deixa claro.
   */
  detecteSeparadorDecimal(linhas: Array<any>) {
    if(!linhas?.length)
      return null

    const cabecalho = linhas[0] || []
    const indicesPreco = cabecalho
      .map((titulo: string, indice: number) => this.obtenhaNomeColunaPorCabecalho(titulo) === 'Preço' ? indice : -1)
      .filter((indice: number) => indice >= 0)

    let virgulas = 0, pontos = 0
    let exemplo: any = null

    for(const linha of linhas.slice(1, 201)) {
      if(!Array.isArray(linha)) continue

      const valores = indicesPreco.length ? indicesPreco.map((indice: number) => linha[indice]) : linha

      for(const valor of valores) {
        const separador = this.obtenhaSeparadorDecimalDoValor(valor)

        if(!separador) continue

        if(separador === ',') virgulas++
        else pontos++

        if(!exemplo) exemplo = {valor, separador}
      }
    }

    if(!virgulas && !pontos)
      return null

    const separador = virgulas >= pontos ? ',' : '.'

    if(exemplo?.separador === separador)
      this.valorExemploPreco = this.converteEmNumero(exemplo.valor, separador)

    return separador
  }

  private obtenhaSeparadorDecimalDoValor(valor: any) {
    const texto = String(valor ?? '').trim().replace(/^R\$\s*/i, '')

    if(!/^-?\d{1,3}([.,]\d{3})*([.,]\d{1,2})?$/.test(texto))
      return null

    const decimal = texto.match(/([.,])\d{1,2}$/)

    return decimal ? decimal[1] : null
  }

  private converteEmNumero(valor: any, separadorDecimal: string) {
    const separadorMilhar = separadorDecimal === ',' ? '.' : ','
    const texto = String(valor ?? '')
      .trim()
      .replace(/^R\$\s*/i, '')
      .split(separadorMilhar).join('')
      .replace(separadorDecimal, '.')

    const numero = Number(texto)

    return isNaN(numero) ? null : numero
  }

  private apliqueSeparadorDecimalDetectado() {
    this.valorExemploPreco = null
    const detectado = this.detecteSeparadorDecimal(this.conteudoArquivo)

    this.separadorDecimalDetectado = !!detectado

    if(detectado)
      this.separadorDecimal = this.opcoesSeparadorDecimal
        .find((opcao: any) => opcao.codigo === detectado)
  }

  selecionouArquivo(e: any) {
    const arquivoSelecionado = e.files && e.files[0]

    if(!arquivoSelecionado || arquivoSelecionado.validationErrors?.length) {
      this.arquivo = null
      this.conteudoArquivo = []
      this.separadorColunas = null
      this.mensagemErro = 'Selecione um arquivo CSV válido com no máximo 10MB.'
      return
    }

    this.arquivo = arquivoSelecionado.rawFile;
    this.conteudoArquivo = []
    this.separadorColunas = null
    let reader = new FileReader();
    reader.readAsText(this.arquivo, "UTF-8");
    reader.onload =  (evt) => {
      let conteudo: any =  evt.target.result ;

      let linhas = conteudo.match(/[^\r\n]+/g) || []
      const separadorColunas = this.obtenhaSeparadorColunas(linhas[0] || '')
      this.separadorColunas = separadorColunas

      for(let linha of linhas) {
        let colunas =  this.CSVtoArray(linha, separadorColunas)

        /*
        let objeto: any = {}

        for(let i = 0; i < colunas.length; i++)
          objeto[i] = colunas[i]*/

        if(colunas)
          this.conteudoArquivo.push(colunas);
      }

      if(!this.conteudoArquivo.length) {
        this.mensagemErro = 'Não foi possível identificar linhas válidas no arquivo CSV.'
        return
      }

      this.apliqueSeparadorDecimalDetectado();

      let i = 0;
      this.colunasImportar = []; // Limpa colunas anteriores
      if(this.conteudoArquivo.length > 0)
        this.conteudoArquivo[0].forEach( (item: string) => {
          let coluna: any = {
            indice: i,
            coluna: null
          };
          const nomeColuna = this.obtenhaNomeColunaPorCabecalho(item);

          if(nomeColuna)
            coluna.coluna = this.obtenhaColuna(nomeColuna);

          this.colunasImportar.push( coluna )
          i++
        })

      this.fecheMensagemErro();
      this.ajusteTamanhoDaJanela();
    }
    reader.onerror = (evt) => {
      this.mensagemErro = "Houve um erro ao ler o arquivo."
    }


  }

  primeirasLinhas(){
    return (this.conteudoArquivo || [])
      .filter((linha: any) => Array.isArray(linha))
      .slice(1, 11)
  }
}
